import { AppEntities } from "../../../../config/entities";
import React from "react";
import { NewCatalogListView } from "../../../Shared/NewCatalogListView";
import { IListViewField } from "../../../Shared/ILIstViewField";

const ExpenseItemList = () => {
    const fields: IListViewField[] = [
    ];

    return (
        <>
            <NewCatalogListView fields={fields} entity={AppEntities.ExpenseItem} />
        </>
    );
}

export default ExpenseItemList;